import * as React from 'react';
import { Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { RoutePath } from './../../routes';

export default function AppRoot() {
  return (
    <Box sx={{ minWidth: 0, width: '100%' }}>
      <CssBaseline />
      <RoutePath />
    </Box>
  );
}
